import styled from 'styled-components'
import {DataLoading} from '../components/data-loading/data-loading'

import type {JSX} from 'react'

const FullScreen = styled.div`
    height: 100vh;
`

export function FullScreenLoading(): JSX.Element {
    return (
        <FullScreen>
            <DataLoading />
        </FullScreen>
    )
}
